// extracted by mini-css-extract-plugin
export default {"label":"Slider_label__zryFI","slider":"Slider_slider__pUyvh","labelWrapper":"Slider_labelWrapper__gAtUX"};